var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMaximizeIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0V2H2V6H0V0H6ZM0 18V12H2V16H6V18H0ZM20 18H14V16H18V12H20V18ZM20 6H18V2H14V0H20V6Z",
    fill: "#182534"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMaximizeIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/maximize_icon.fdb57b0a.svg";
export { ForwardRef as ReactComponent };